export default __webpack_public_path__ + "static/tour-view-blur-cd283cdbad2c495755a35592d1fd5419.png";